import gql from 'graphql-tag'

const mapItem = gql`
    fragment mapItem on MapItemType {
        id
        name
        embeddedUrl
        widgetLink
        widget
        coords
        shape
        forMobile
        space {
            id
            name
            type
        }
    }
`

export const mapSpaceQuery = gql`
    query mapSpace($eventSlug: EventID!, $filters: MapSpaceFilter) {
        event(id: $eventSlug) {
            mapSpaces(filters: $filters) {
                edges {
                    node {
                        id
                        items {
                            ...mapItem
                        }
                        parent {
                            name
                            enableChat
                            published
                            helpContent
                            helpContentType
                            image
                            slug
                        }
                    }
                }
            }
        }
    }
    ${mapItem}
`
